var Handlebars = require("../../../lice.thomasjacob.de/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<span class=\"input-message\">"
    + container.escapeExpression(((helper = (helper = helpers["short"] || (depth0 != null ? depth0["short"] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"short","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"useData":true});